<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <div>
      <el-col :span="4">
        <el-input v-model="filters.key" placeholder="物资名称/仓库名称"></el-input>
      </el-col>
      <el-col :span="8">
        <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <!-- <el-date-picker
          type="date"
          placeholder="结束日期"
          v-model="filters.endTime"
        ></el-date-picker> -->
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getMatBalanceSub(1)">查询</el-button>
      </el-col>
    </div>
    <!--列表-->
    <el-table :data="MatBalanceSub" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      style="width: 100%" height="600" :border="true">
      <el-table-column prop="MatName" label="物资名称"></el-table-column>
      <el-table-column prop="WarehouseName" label="仓库名称"></el-table-column>
      <el-table-column prop="PeriodPrice" label="账面单价" :formatter="rounding"></el-table-column>
      <el-table-column prop="PeriodQuantity" label="账面数量" :formatter="rounding"></el-table-column>
      <el-table-column prop="PeriodAmount" label="账面金额" :formatter="rounding"></el-table-column>
      <el-table-column prop="InPrice" label="本期入库单价" :formatter="rounding"></el-table-column>
      <el-table-column prop="InQuantity" label="本期入库数量" :formatter="rounding"></el-table-column>
      <el-table-column prop="InAmount" label="本期入库金额" :formatter="rounding"></el-table-column>
      <el-table-column prop="OutPrice" label="本期出库单价" :formatter="rounding"></el-table-column>
      <el-table-column prop="OutQuantity" label="本期出库数量" :formatter="rounding"></el-table-column>
      <el-table-column prop="OutAmount" label="本期出库金额" :formatter="rounding"></el-table-column>
      <el-table-column prop="Price" label="单价" :formatter="rounding"></el-table-column>
      <el-table-column prop="Quantity" label="数量" :formatter="rounding"></el-table-column>
      <el-table-column prop="Amount" label="金额" :formatter="rounding"></el-table-column>
      <el-table-column prop="LastPrice" label="期末单价" :formatter="rounding"></el-table-column>
      <el-table-column prop="LastAmount" label="期末金额" :formatter="rounding"></el-table-column>
      <el-table-column prop="LastQuantity" label="期末数量" :formatter="rounding"></el-table-column>
      <el-table-column prop="StartTime" label="开始时间" sortable></el-table-column>
      <el-table-column prop="EndTime" label="结束时间" sortable></el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canRecalculation" type="danger" @click="() => {
              currentRow = scope.row;
              handleRecalculation();
            }
            ">
            重置
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入MatBalanceSub.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/matbalancesub";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: {
    Toolbar,
    //  TableDataDialog
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {},
      MatBalanceSub: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
    };
  },
  computed: {
    //计算属性,判断是否有权删除
    canRecalculation() {
      let index = this.buttonList.findIndex((s) => s.name === "重置");
      return index > -1;
    },
  },
  methods: {
    rounding(row, column) {
      return parseFloat(row[column.property]).toFixed(2);
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // //工具条绑定事件方法
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getMatBalanceSub();
    },
    //获取施工部位列表
    getMatBalanceSub(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        key: this.filters.key,
        startTime: this.filters.startTime,
        endTime: this.filters.endTime,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getMatBalanceSubListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.MatBalanceSub = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
      });
    },
    //执行删除
    handleRecalculation() {
      if (this.currentRow == null) {
        this.$message({
          message: "请选择要重置的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认重置选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = Object.assign({}, this.currentRow);

          api.Recalculation(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "重置成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getMatBalanceSub();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getMatBalanceSub();
    },
  },
  mounted() {
    this.getMatBalanceSub();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
